import { setCookie } from "../utils/cookie";

// handle theme changes
export function registerThemeHandler() {
  const themeBtn = document.getElementsByClassName("theme-toggle")[0];
  themeBtn.addEventListener("click", (e) => {
    e.stopImmediatePropagation();
    if (document.body.classList.contains("light")) {
      document.body.classList.remove("light");
      document.body.classList.add("dark");
      themeBtn.classList.remove("active");
      setCookie("mtheme", "dark", 365);
    } else {
      document.body.classList.remove("dark");
      document.body.classList.add("light");
      themeBtn.classList.remove("active");
      setCookie("mtheme", "light", 365);
    }
  });
}
